import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {SaleInvoiceModel} from '../saleInvoice.model';
import {SaleInvoiceSummaryConverter} from './saleInvoiceSummary.converter';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceConverter extends HttpModelConverter<SaleInvoiceModel> {

    constructor(private saleInvoiceSummaryConverter: SaleInvoiceSummaryConverter) {
        super();
    }

    protected createInstance(): SaleInvoiceModel {
        return new SaleInvoiceModel();
    }

    protected enrichObject(result: SaleInvoiceModel, src: SaleInvoiceModel) {
        result.summary = this.saleInvoiceSummaryConverter.convert(src.summary);
    }
}
